import { CSSObject } from "@emotion/react";

import { useMainBannerStore } from "@/stores/useMainBannerStore";

import { colors } from "@dotnet/telematics-design-system";

import useGeneralHeights from "../../shared/hooks/useGeneralHeights";

export const useStyles = () => {
  const mainBannerHeight = useMainBannerStore(state => state.height);

  const { NAVBAR_HEIGHT } = useGeneralHeights(mainBannerHeight);
  return {
    desktopDetailsAside: {
      position: "fixed",
      zIndex: 1200,
      right: "0",
      top: NAVBAR_HEIGHT,
      bottom: "0",
      boxShadow: "0px 1px 4px 0px rgba(15, 23, 42, 0.12)",
      height: "unset",
      overflowY: "unset"
    },
    detailsContentContainer: {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center"
    },
    detailsPaperCard: {
      margin: "24px 16px 24px 24px",
      boxShadow: "none",
      backgroundColor: colors.white,
      borderRadius: "8px"
    },
    firstCollapsablePaperCard: {
      margin: "8px 16px 24px 24px",
      boxShadow: "none",
      backgroundColor: colors.white,
      borderRadius: "8px"
    },
    detailsPaperCardContent: {
      padding: "16px"
    },
    paperCardTitle: {
      marginBottom: "16px"
    },
    paperCardItem: {
      display: "flex",
      marginBottom: "16px",
      alignItems: "center",
      wordBreak: "break-word"
    },
    paperCardItemTitle: {
      width: "112px"
    },
    paperCardItemFixedHeight: {
      height: "24px"
    },
    paperCardItemAlignUnset: {
      alignItems: "unset"
    },
    paperCardItemAlignStart: {
      alignItems: "start"
    },
    collapsableTitleArea: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    },
    collapseArrow: {
      cursor: "pointer",
      display: "flex",
      alignItems: "center"
    },
    dataTypeIconsBlock: {
      display: "flex",
      "& > span": { marginRight: "4px" }
    },
    detailsTitleArea: {
      margin: "0 auto",
      padding: "22px 24px 24px 24px"
    },
    detailsTitleAreaWithLoader: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingBottom: "8px",
      position: "relative",
      height: "25px !important"
    },
    closeDetailsButton: {
      position: "absolute",
      bottom: "8px",
      right: "-20px"
    },
    detailsTitle: {
      width: "95%", // 95% to make sure the title is not too close to the close button
      minWidth: "300px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap"
    },
    detailsTitleWithInlineAction: {
      display: "flex",
      alignItems: "center"
    },
    detailsBlockTitleArea: {
      display: "flex",
      justifyContent: "space-between",
      marginRight: "22px"
    },
    actionTextLinkBlue: {
      color: colors?.blue700,
      marginTop: "16px",
      cursor: "pointer",
      textDecoration: "underline"
    },
    actionTextLinkRed: {
      color: colors?.red800,
      marginTop: "8px",
      cursor: "pointer",
      textDecoration: "underline"
    },
    detailsBannerMessage: { margin: "8px 6px 24px 24px" },
    statusTitle: {
      lineHeight: "24px"
    },
    customTabsContainer: {
      marginTop: "16px",
      display: "flex",
      width: "100%",
      overflow: "hidden"
    },
    customTabsArrowButtonBorder: {
      borderBottom: `1px solid ${colors?.gray200}`,
      borderBottomLeftRadius: "0",
      borderBottomRightRadius: "0"
    },
    leftTabsArrowButton: {
      width: "24px",
      background:
        "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)",
      "&.Mui-disabled": {
        background:
          "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
      },

      "&.Mui-focusVisible, &:hover, &:active, &:focus": {
        background:
          "linear-gradient(270deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
      }
    },

    rightTabsArrowButton: {
      width: "28px", // 24px padding + 4px addition due to scroll bar
      background:
        "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)",

      "&.Mui-disabled": {
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
      },
      "&.Mui-focusVisible, &:hover, &:active, &:focus": {
        background:
          "linear-gradient(90deg, rgba(255, 255, 255, 0.00) 0%, #FFF 50%)"
      }
    },
    paperCardTitleWithInfo: {
      display: "flex",
      gap: "4px",
      alignItems: "center"
    },
    customInfoTooltip: { display: "flex", flexDirection: "column" },
    copyButtonCustomStyle: {
      width: "24px",
      marginLeft: "8px",
      height: "24px"
    }
  } as CSSObject;
};
